export default {
  currentTeacherList: [],
  currentSelectedTeacher: {},
  selectedCampuse: {},
  campusTeacherList: [],
  classTeacherList: [],
  listenStorage: false,
}
